<template>
  <div class="emh-side-filters-locations-category">
    <ui-button-group-tab-view
      v-if="locationFilterTypeOptions.length"
      :disabled="isLoading"
      :tabs="locationFilterTypeOptions"
      group-name="location-tabs"
      :initial-tab-value="locationFilterTab.toString()"
      manage-tab-selection
      data-test-id="emh-side-filters-locations-category__tabs-view"
    >
      <template #[locationFilterTypes.area]>
        <emh-filter-location
          :is-loading="isLoading"
          :filter="locationsFilter"
          :selected-filter-params="locationFilterParams"
          :allowed-list="allowedList"
          display-column
          @params-updated="setLocationFilterParams"
          @vendors-selected="vendorsSelected"
          @reset="resetLocationFilter"
        />
      </template>

      <template #[locationFilterTypes.dealer]>
        <emh-side-filters-dealer-filter
          :is-loading="isLoading"
          :dealers="dealers"
          :selected-dealer="dealerFilterInfo"
          :allowed-list="allowedList"
          @vendor-selected="vendorSelected"
          @reset="resetDealerFilter"
        />
      </template>
    </ui-button-group-tab-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'EmhSideFiltersLocationsCategory',
});
</script>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import UiButtonGroupTabView from '@dh-io-emh/ui/src/form/buttonGroup/buttonGroupTabView/ButtonGroupTabView.vue';
import { ButtonGroupTabView } from '@dh-io-emh/ui/src/form/buttonGroup/buttonGroupTabView/button-group-tab-view.model';
import EmhFilterLocation from '../../filterLocation/index.vue';
import EmhSideFiltersDealerFilter from './sideFiltersDealerFilter/SideFiltersDealerFilter.vue';
import { FilterCode, IProductFilterGroup } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import { findFilterByCode } from '../../../utils/helpers';
import { LocationFilterTabs, useLocationsFilter } from '../../../composables/locations-filter.composable';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
  filterCategory: {
    type: Object as PropType<IProductFilterGroup>,
    required: true,
  },
});

const emit = defineEmits(['change']);

const { filterCategory } = toRefs(props);

const locationsFilter = computed(() => findFilterByCode(filterCategory?.value.filters, FilterCode.locations));

const {
  locationFilterTab,
  locationFilterTabs,
  locationFilterParams,
  dealerFilterInfo,
  setLocationFilterParams,
  allowedList,
  dealers,
  locationSearchHeadline,
  dealerSearchHeadline,
  resetLocationFilter,
  resetDealerFilter,
  vendorsSelected,
  vendorSelected,
} = useLocationsFilter({ filter: locationsFilter, emit });

const locationFilterTypes = {
  area: LocationFilterTabs.Area,
  dealer: LocationFilterTabs.Dealer,
};

const locationFilterTypeOptions = computed(() => {
  const tabOptionsMapping: { [key in LocationFilterTabs]: ButtonGroupTabView } = {
    [LocationFilterTabs.Area]: {
      label: locationSearchHeadline.value,
      value: LocationFilterTabs.Area.toString(),
    },
    [LocationFilterTabs.Dealer]: {
      label: dealerSearchHeadline.value,
      value: LocationFilterTabs.Dealer.toString(),
    },
  };

  return locationFilterTabs.value.map((tab) => tabOptionsMapping[tab]);
});
</script>
